/* eslint-disable no-unused-vars */
import moment from 'moment'

export const STATUS_CHECKOUT = 'Carrinho de compras'

export const STATUS_CANCELLED = 'Pedido cancelado'
export const STATUS_CANCELLED_NEW = 'CANCELLED'
export const STATUS_CANCELLED_BY_USER = 'Cancelamento solicitado'

export const STATUS_CONFIRMED = 'Confirmado'

export const STATUS_WAITING_CONFIRMATION = 'Confirmando disponibilidade'

export const STATUS_DELIVERING = 'Em processo de entrega'
export const STATUS_AVAILABLE = 'Em processo de entrega'

export const STATUS_DELIVERED = 'Pedido entregue'
export const STATUS_DELIVERED_NEW = 'Pedido Entregue'

export const STATUS_FAILED = 'FAILED'

export const AGG_STATUS_CANCELLED = 'cancelled'
export const AGG_STATUS_DELIVERED = 'delivered'
export const AGG_STATUS_CHECKOUT = 'checkout'

export enum ORDER_STATUS {
  RECEIVED = 'RECEIVED',
  WAITING_PAYMENT = 'WAITING_PAYMENT',
  FAILED = 'FAILED',
  WAITING_CONFIRMATION = 'WAITING_CONFIRMATION',
  CONFIRMED = 'CONFIRMED',
  DELIVERING = 'DELIVERING',
  AVAILABLE = 'AVAILABLE',
  DELIVERED = 'DELIVERED',
  CANCELLED = 'CANCELLED'
}
export type DateFormat = {
  format: string,
  interval: string
}

export type LossesBase = {
  quantity: number
  gmv: number
}

export interface LossesCancelled {
  CANCELLATION_ACTIVATION_TEST: LossesBase
  CANCELLATION_AREA_NOT_COVERED: LossesBase
  CANCELLATION_DEVELOPMENT_TESTS: LossesBase
  CANCELLATION_GAVE_UP: LossesBase
  CANCELLATION_LACKING_DATA: LossesBase
  CANCELLATION_OTHER: LossesBase
  CANCELLATION_OUT_OF_STOCK: LossesBase
  CANCELLATION_PAST_DELIVERY_TIME: LossesBase
  CANCELLATION_PAYMENT_DENIED: LossesBase
  CANCELLATION_POSSIBLE_FRAUD: LossesBase
  CANCELLATION_WRONG_ADDRESS: LossesBase
  total: LossesBase
}

export interface Losses {
  date: string
  dateFormat: DateFormat
  delivered: LossesBase
  failed: {
    PAYMENT_DENIED: LossesBase
    AUTOMATIC_BLOCKLIST: LossesBase
    AUTOMATIC_ANTIFRAUD: LossesBase
    total: LossesBase
  }
  cancelled: LossesCancelled
}

export type LossesInput = {
  year: number,
  month: number,
  time_zone: string
}

export interface FilterLosses {
  dateRange?: {
    initialDate: moment.Moment|string|null,
    finalDate: moment.Moment|string|null,
    format?: string,
    time_zone?: string
  }
}
